// src/components/Navbar.js
import React, { useState } from "react";
import { Link } from "react-router-dom";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [verticalsOpen, setVerticalsOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className="container navbar-content">
        <img src="/HashSeal_Logo.webp" alt="HashSeal Logo" className="nav-logo" />
        <span className="nav-brand">HashSeal</span>

        {/* Burger menu icon */}
        <div
          className={`nav-toggle ${open ? "open" : ""}`}
          onClick={() => setOpen(!open)}
          role="button"
          tabIndex={0}
          onKeyDown={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          <div className="bar" />
          <div className="bar" />
          <div className="bar" />
        </div>

        {/* Nav links */}
        <div className={`nav-links ${open ? "nav-open" : ""}`}>
          <Link to="/" onClick={() => setOpen(false)}>Home</Link>
          {/* <a href="#features" onClick={() => setOpen(false)}>Features</a> */}
          <a href="#how" onClick={() => setOpen(false)}>How It Works</a>
          <Link to="/onboarding" onClick={() => setOpen(false)}>Onboarding</Link>
          <Link to="/case-studies" onClick={() => setOpen(false)}>Case Studies</Link>
          <a href="#faq" onClick={() => setOpen(false)}>FAQ</a>
          {/* <a href="#download" onClick={() => setOpen(false)}>App</a> */}
          <Link to="/dashboard">Dashboard</Link>

          {/* Verticals dropdown */}
          <div
            className={`nav-dropdown ${verticalsOpen ? "open" : ""}`}
            onMouseEnter={() => setVerticalsOpen(true)}
            onMouseLeave={() => setVerticalsOpen(false)}
          >
            <span className="nav-dropdown-label">Verticals ▾</span>
            <div className="nav-dropdown-menu">
              <Link to="/education" onClick={() => setOpen(false)}>Education</Link>
              {/* Future verticals */}
              <Link to="/insurance" onClick={() => setOpen(false)}>Insurance</Link>
              <Link to="/esg" onClick={() => setOpen(false)}>ESG</Link>
              <Link to="/sports" onClick={() => setOpen(false)}>Sports Events</Link>
              <Link to="/museum" onClick={() => setOpen(false)}>Arts and Heritage</Link>

              {/* <Link to="/healthcare" onClick={() => setOpen(false)}>Healthcare</Link> */}
            </div>
          </div>
        </div>

        {/* Get Started button */}
        <Link to="/seal" className="btn btn-nav" onClick={() => setOpen(false)}>
          Get Started
        </Link>
      </div>
    </nav>
  );
}
